import { render, staticRenderFns } from "./LLMChat.vue?vue&type=template&id=5c0efaf5&scoped=true"
import script from "./LLMChat.vue?vue&type=script&lang=js"
export * from "./LLMChat.vue?vue&type=script&lang=js"
import style0 from "./LLMChat.vue?vue&type=style&index=0&id=5c0efaf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0efaf5",
  null
  
)

export default component.exports